.loader {
  display: flex;
  position: relative;
  top: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  &.overlay {
    position: absolute;
  }

  .overlay {
    z-index: 30;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    background-color: rgba(var(--neutral-rgb), 0.7);
  }

  .spin {
    display: flex;
    z-index: 35;
    position: relative;
    justify-content: center;
    align-items: center;
    margin-right: auto;
    margin-left: auto;

    svg {
      width: 100%;
      height: 100%;
      animation: spin 1s linear infinite;
    }
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
